<template>
  <v-app>
    <v-overlay :value="$store.state.ui.loading" opacity="0.28" z-index="9999">
      <div class="loader-brand">
        <div class="loader-orbit">
          <img :src="logo" class="loader-img" />
        </div>

        <div class="loader-text">
          {{ $store.state.ui.loadingText || 'Cargando...' }}
        </div>
      </div>
    </v-overlay>

    <component :is="showLayout ? 'HeaderAdm' : 'app-header'" />

    <v-main>

      <router-view />

      <v-btn v-if="!showLayout" class="whatsapp-float mini-float" color="green" dark fab small :href="WhatsApp"
        target="_blank">
        <v-icon small>mdi-whatsapp</v-icon>
      </v-btn>

      <v-btn v-if="!showLayout" class="call-float mini-float" color="blue darken-3" dark fab small
        :href="`tel:${phoneNumber}`">
        <v-icon small>mdi-phone</v-icon>
      </v-btn>

      <v-btn v-if="!showLayout" v-show="showScroll" fab dark small color="blue darken-3"
        class="scroll-to-top mini-float" @click="scrollToTop">
        <v-icon small>mdi-arrow-up</v-icon>
      </v-btn>
      <!--Alerta sesión expirada -->
      <v-dialog v-model="showSessionModal" persistent max-width="460" content-class="session-expired-dialog">
        <v-card class="session-card rounded-xl">
          <v-card-text class="pa-6 pa-sm-8 text-center">
            <div class="session-icon-wrapper mb-4">
              <v-icon color="warning" size="42">
                mdi-clock-alert-outline
              </v-icon>
            </div>

            <div class="text-h6 font-weight-bold mb-2">
              {{ sessionModal.title || 'Sesión expirada' }}
            </div>

            <div class="session-message mb-6">
              {{ sessionModal.message || 'Por seguridad, tu sesión se cerró porque pasaron más de 2 minutos sin actividad.Para continuar, inicia sesión de nuevo.' }}
            </div>

            <v-btn color="primary" large block class="font-weight-medium text-none" @click="goToLogin">
              Iniciar sesión de nuevo
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>

    <Footer v-if="!showLayout" />
  </v-app>
</template>

<script>

import HeaderAdm from '@/components/LayoutAdm/HeaderAdm.vue'
import AppHeader from '@/components/Layout/AppHeader.vue'
import Footer from '@/components/Layout/AppFooter.vue'

import { EventBus } from '@/functions/event-bus'
import { setLogoutTimer, clearLogoutTimer } from './plugins/auth'

export default {
  name: 'App',

  components: {
    HeaderAdm,
    AppHeader,
    Footer
  },

  data() {
    const minutes = Number(process.env.VUE_APP_MAX_INACTIVITY_MINUTES) || 15
    const maxInactivity = minutes * 60 * 1000
    return {
      logo: 'https://medicover.mx/img/mari.png',
      WhatsApp: 'https://wa.me/524442765784',
      phoneNumber: '4448135480',
      showScroll: false,

      showSessionModal: false,
      sessionModal: {
        title: '',
        message: ''
      },

      inactivityTimer: null,
      maxInactivity: maxInactivity,
      sessionExpiredShown: false
    }
  },

  computed: {
    showLayout() {
      return this.$route.meta.layout === true
    }
  },

  created() {
    const img = new Image()
    img.src = 'https://medicover.mx/img/mari.png'
    const token = localStorage.getItem('token')

    if (token) {
      this.startTokenTimer(token)
      this.startInactivityControl()
    }

    EventBus.$on('toggle-loading', this.handleLoading)
    EventBus.$on('session-expired', this.handleSessionExpired)
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    EventBus.$off('toggle-loading', this.handleLoading)
    EventBus.$off('session-expired', this.handleSessionExpired)

    window.removeEventListener('scroll', this.handleScroll)
    this.removeInactivityControl()
    clearLogoutTimer && clearLogoutTimer()
  },

  methods: {
    handleLoading(state) {
      this.isLoading = state
    },

    handleScroll() {
      this.showScroll = window.scrollY > 200
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    startTokenTimer(token) {
      setLogoutTimer(token, () => {
        this.expireSession(
          'Sesión expirada',
          'Tu sesión expiró porque el tiempo de acceso terminó. Inicia sesión de nuevo para continuar.'
        )
      })
    },

    startInactivityControl() {
      const events = ['mousemove', 'mousedown', 'click', 'scroll', 'keydown', 'touchstart']

      events.forEach(event => {
        window.addEventListener(event, this.resetInactivityTimer)
      })

      this.resetInactivityTimer()
    },

    removeInactivityControl() {
      const events = ['mousemove', 'mousedown', 'click', 'scroll', 'keydown', 'touchstart']

      events.forEach(event => {
        window.removeEventListener(event, this.resetInactivityTimer)
      })

      clearTimeout(this.inactivityTimer)
      this.inactivityTimer = null
    },

    resetInactivityTimer() {
      const token = localStorage.getItem('token')
      if (!token || this.sessionExpiredShown) return

      clearTimeout(this.inactivityTimer)

      this.inactivityTimer = setTimeout(() => {
        this.expireSession(
          'Sesión expirada',
          'Tu sesión expiró porque pasó demasiado tiempo sin actividad. Inicia sesión de nuevo para continuar.'
        )
      }, this.maxInactivity)
    },

    expireSession(title, message) {
      if (this.sessionExpiredShown) return

      this.sessionExpiredShown = true
      this.removeSessionData()
      this.removeInactivityControl()
      clearLogoutTimer && clearLogoutTimer()

      EventBus.$emit('session-expired', { title, message })
    },

    removeSessionData() {
      localStorage.removeItem('id')
      localStorage.removeItem('token')
      localStorage.removeItem('nombres')
      localStorage.removeItem('aPaterno')
      localStorage.removeItem('aMaterno')
      localStorage.removeItem('email')
      localStorage.removeItem('codAge')
      localStorage.removeItem('menu')
      localStorage.removeItem('idTarjetaTxt')
      localStorage.removeItem('idTarjeta')
      localStorage.removeItem('NombresApaterno')
      localStorage.removeItem('tipoUsuario')
    },

    handleSessionExpired(payload) {
      if (this.showSessionModal) return

      this.sessionModal = payload
      this.showSessionModal = true
    },

    goToLogin() {
      const tipoUsuario = localStorage.getItem('tipoUsuario')

      let rutaLogin = '/'

      switch (tipoUsuario) {
        case 'admin':
          rutaLogin = '/login-admin'
          break
        case 'cliente':
          rutaLogin = '/login-cliente'
          break
        case 'hospital':
          rutaLogin = '/login-hospital'
          break
        case 'medico':
          rutaLogin = '/login-medico'
          break
        case 'agente':
          rutaLogin = '/login-agente'
          break
        case 'colaborador':
          rutaLogin = '/login-colaborador'
          break
      }

      this.showSessionModal = false
      this.sessionExpiredShown = false

      this.$router.push({ path: rutaLogin })
    }
  }
}
</script>
<style lang="css" scoped>
.session-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.session-icon-wrapper {
  width: 72px;
  height: 72px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff8e1;
}

.session-message {
  font-size: 15px;
  line-height: 1.6;
  color: #5f6368;
}

@media (max-width: 600px) {
  .session-message {
    font-size: 14px;
    line-height: 1.5;
  }
}

.loader-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loader-orbit {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulseSoft 1.6s ease-in-out infinite;
}

.loader-img {
  width: 54px;
  height: auto;
  animation: floatLogo 1.8s ease-in-out infinite;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.18));
}

.loader-text {
  margin-top: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.3px;
}

@keyframes floatLogo {
  0% {
    transform: translateY(0) scale(1);
  }

  50% {
    transform: translateY(-6px) scale(1.05);
  }

  100% {
    transform: translateY(0) scale(1);
  }
}

@keyframes pulseSoft {
  0% {
    box-shadow: 0 0 0 0 rgba(94, 169, 219, 0.35);
  }

  70% {
    box-shadow: 0 0 0 16px rgba(94, 169, 219, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(94, 169, 219, 0);
  }
}
</style>